import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState, useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Button, Form, Alert } from 'react-bootstrap'; // Adicionado Alert
import { Link, useNavigate } from 'react-router-dom';
import Spinner from '../../shared/spinner';
import { ButtonAlterar, ButtonAtivar, ButtonInativar } from '../../shared/buttons';
import { format } from 'date-fns';
import { faFileExcel, faFilter, faRefresh, faFileImport, faDownload, faTimes } from '@fortawesome/free-solid-svg-icons'; // Novos ícones
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InputMask from 'react-input-mask';
import { FiltroUsuarioDTO } from '../../shared/dto/filtroUsuarioDTO';
import ResponsivePagination from 'react-responsive-pagination';
import UsuarioService from '../../services/usuarioService';
import CustomAlert from '../../shared/customAlert';
import ConfirmModal from '../../shared/customAlertConfirm';
import { Role } from '../../shared/model/role';
import { UUID } from 'crypto';
import { UsuarioDTO } from '../../shared/dto/usuarioDTO';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import RelatorioService from '../../services/relatorioService';
import ImportacaoService from '../../services/importacaoService'; // <--- Importado

import MatrizService from '../../services/matrizService';
import PromotoraService from '../../services/promotoraService';
import SupervisorService from '../../services/supervisorService';
import OperadorService from '../../services/operadorService';
import PontoVendaService from '../../services/pontoVendaService';
import { useSlug } from '../hooks/UseSlug';
import { ProtectedActionInterno, ProtectedActionOriginador, ProtectedAction } from '../../AccessControl';


function UsuarioComponent() {
  useVerificaPermissao();
  const slug = useSlug(); // 2. Obtendo o slug
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);

  const statusFl = [
    { value: 'Todos', label: 'Todos' },
    { value: 'Ativos', label: 'Ativos' },
    { value: 'Inativos', label: 'Inativos' },
  ];

  const navigate = useNavigate();

  // Services
  const relatorioService: RelatorioService = new RelatorioService();
  const usuarioService: UsuarioService = new UsuarioService();
  const matrizService: MatrizService = new MatrizService();
  const promotoraService: PromotoraService = new PromotoraService();
  const supervisorService: SupervisorService = new SupervisorService();
  const operadorService: OperadorService = new OperadorService();
  const pontoVendaService: PontoVendaService = new PontoVendaService();
  const importacaoService = new ImportacaoService(); // <--- Instância

  const [loading, setLoading] = useState(true);
  const [usuarios, setUsuarios] = useState<UsuarioDTO[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);

  // Controle de Painéis
  const [filtros, setFiltros] = useState(false);
  const [importacaoOpen, setImportacaoOpen] = useState(false); // <--- State Painel Importação

  // Filtros
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [loginFiltro, setLoginFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');
  const [cpfFiltro, setCpfFiltro] = useState('');
  const [statusFiltro, setStatusFiltro] = useState(statusFl[0].value);
  const [roleFiltro, setRoleFiltro] = useState<Role>();
  const [dataInicioFiltro, setDataInicioFiltro] = useState<Date | undefined>();
  const [dataFimFiltro, setDataFimFiltro] = useState<Date | undefined>();

  const [matrizFiltro, setMatrizFiltro] = useState('');
  const [promotoraFiltro, setPromotoraFiltro] = useState('');
  const [supervisorFiltro, setSupervisorFiltro] = useState('');
  const [operadorFiltro, setOperadorFiltro] = useState('');
  const [pontoVendaFiltro, setPontoVendaFiltro] = useState('');

  const qtdRegistros = [10, 20, 30, 50, 100];
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{ id: any; ativo: boolean } | null>(null);

  // Listas para popular selects
  const [matrizes, setMatrizes] = useState<any[]>([]);
  const [promotoras, setPromotoras] = useState<any[]>([]);
  const [supervisores, setSupervisores] = useState<any[]>([]);
  const [operadores, setOperadores] = useState<any[]>([]);
  const [pontosVenda, setPontosVenda] = useState<any[]>([]);

  // States de Importação
  const [fileToUpload, setFileToUpload] = useState<File | null>(null);
  const [importLoading, setImportLoading] = useState(false);
  const [importMessage, setImportMessage] = useState<{ type: 'success' | 'danger', text: string } | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // --- Toggle Painéis ---
  const toggleFiltros = () => {
    setFiltros(!filtros);
    setImportacaoOpen(false); // Fecha importação ao abrir filtros
  };

  const toggleImportacao = () => {
    setImportacaoOpen(!importacaoOpen);
    setFiltros(false); // Fecha filtros ao abrir importação
    setImportMessage(null);
  };

  // --- Listagem ---
  const listarTodosUsuarios = async (max: number) => {
    try {
      setLoading(true);

      let filtro = new FiltroUsuarioDTO();

      filtro.idMatriz = matrizFiltro;
      filtro.idPromotora = promotoraFiltro;
      filtro.idSupervisor = supervisorFiltro;
      filtro.idOperador = operadorFiltro;
      filtro.idPontoVenda = pontoVendaFiltro;

      filtro.codigo = codigoFiltro;
      filtro.login = loginFiltro;
      filtro.nome = nomeFiltro;
      filtro.cpf = cpfFiltro;
      filtro.status = statusFiltro === 'Todos' ? null : statusFiltro === 'Ativos' ? true : false;
      filtro.idRole = roleFiltro?.id!;

      if (dataInicioFiltro) {
        filtro.dataInicio = new Date(dataInicioFiltro);
      }

      if (dataFimFiltro) {
        filtro.dataFim = new Date(dataFimFiltro);
      }

      const responseList = await usuarioService.listarTodosUsuarios(currentPage, max, filtro);
      const jsonList: UsuarioDTO[] = responseList.data.content;
      setUsuarios(jsonList);
      setTotalPages(responseList.data.totalPages);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const ativarInativarUsuario = async (id: any, ativo: boolean) => {
    setCurrentAction({ id, ativo });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (currentAction) {
      const { id } = currentAction;

      try {
        await usuarioService.ativarInativarUsuario(id);
        listarTodosUsuarios(pageSize);
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setCurrentAction(null);
      }
    }
  };

  const carregarDadosAuxiliares = async () => {
    try {
      // console.log("Carregando dados...");

      const [matrizResp, promotoraResp, supervisorResp, operadorResp, pontoVendaResp] = await Promise.all([
        matrizService.listarTodasMatrizesAtivas(),
        promotoraService.listarTodasPromotorasAtivas(),
        supervisorService.listarTodosGerentesAtivos(),
        operadorService.listarTodosOperadoresAtivos(),
        pontoVendaService.listarTodosPontosVendasAtivos()
      ]);

      // Garantir que sempre sejam arrays, mesmo em caso de erro na API
      setMatrizes(Array.isArray(matrizResp?.data) ? matrizResp.data : []);
      setPromotoras(Array.isArray(promotoraResp?.data) ? promotoraResp.data : []);
      setSupervisores(Array.isArray(supervisorResp?.data) ? supervisorResp.data : []);
      setOperadores(Array.isArray(operadorResp?.data) ? operadorResp.data : []);
      setPontosVenda(Array.isArray(pontoVendaResp?.data) ? pontoVendaResp.data : []);

    } catch (error) {
      console.error("Erro ao carregar dados auxiliares", error);
      setMatrizes([]);
      setPromotoras([]);
      setSupervisores([]);
      setOperadores([]);
      setPontosVenda([]);
    }
  };

  // Effect para dados estáticos (roda apenas uma vez na montagem)
  useEffect(() => {
    listarRoles();
    carregarDadosAuxiliares();
  }, []);

  // Effect para listagem de usuários (roda ao mudar página ou size)
  useEffect(() => {
    listarTodosUsuarios(pageSize);
  }, [currentPage, pageSize]);

  const gerarRelatorio = async () => {
    setLoading(true);
    try {
      let filtro = new FiltroUsuarioDTO();
      filtro.codigo = codigoFiltro;
      filtro.login = loginFiltro;
      filtro.nome = nomeFiltro;
      filtro.cpf = cpfFiltro;
      filtro.status = statusFiltro === 'Todos' ? null : statusFiltro === 'Ativos' ? true : false;
      filtro.idRole = roleFiltro?.id!;

      if (dataInicioFiltro) {
        filtro.dataInicio = new Date(dataInicioFiltro);
      }

      if (dataFimFiltro) {
        filtro.dataFim = new Date(dataFimFiltro);
      }

      const response = await relatorioService.gerarRelatorioUsuarios(filtro);
      const contentType = response.headers['content-type'];

      if (contentType === 'text/plain') {
        const errorText = await response.data.text();
        setAlert({ message: errorText, type: 'warning' });
      } else {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Relatorio_Usuarios.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      if (err.response && err.response.status === 500 && err.response.data instanceof Blob) {
        const errorText = await err.response.data.text();
        setAlert({ message: errorText, type: 'warning' });
      } else if (err.response && err.response === 'AXIOS_TIMEOUT') {
        setAlert({ message: 'Ocorreu um erro ao gerar o relatório', type: 'error' });
      }
      console.error(err);
    }
  };

  const listarRoles = async () => {
    try {
      const response = await usuarioService.listarRoles();
      setRoles(response.data);
    } catch (err: any) {
      console.error(err);
    }
  };

  // --- LÓGICA DE IMPORTAÇÃO ---
  const handleDownloadModelo = async () => {
    try {
      // Backend espera 'USUARIO'
      const response = await importacaoService.baixarModelo('USUARIO');

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'modelo_importacao_usuario.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error("Erro ao baixar modelo", error);
      setImportMessage({ type: 'danger', text: 'Erro ao baixar o modelo.' });
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImportMessage(null);
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const extension = file.name.split('.').pop()?.toLowerCase();

      if (extension !== 'xlsx' && extension !== 'csv') {
        setImportMessage({ type: 'danger', text: 'Formato inválido. Apenas .xlsx e .csv são permitidos.' });
        setFileToUpload(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setFileToUpload(file);
    }
  };

  const handleImportar = async () => {
    if (!fileToUpload) {
      setImportMessage({ type: 'danger', text: 'Selecione um arquivo para importar.' });
      return;
    }

    try {
      setImportLoading(true);
      // Chama o endpoint de importação 'USUARIO'
      await importacaoService.importar('USUARIO', fileToUpload);

      setImportMessage({ type: 'success', text: 'Importação realizada com sucesso!' });
      setFileToUpload(null);
      if (fileInputRef.current) fileInputRef.current.value = "";

      // Recarrega lista
      listarTodosUsuarios(pageSize);

      // Fecha painel após sucesso
      setTimeout(() => {
        setImportacaoOpen(false);
        setImportMessage(null);
      }, 3000);

    } catch (error: any) {
      console.error("Erro na importação", error);
      const msg = error.response?.data || 'Erro ao processar importação.';
      setImportMessage({ type: 'danger', text: msg });
    } finally {
      setImportLoading(false);
    }
  };

  /*useEffect(() => {
    listarTodosUsuarios(pageSize);
    listarRoles();
    carregarDadosAuxiliares();
  }, [currentPage]);*/

  return (
    <>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      <div className="position-relative m-md-3">
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
          <h5>Usuários</h5>
        </div>

        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', gap: '10px' }}>
            {/* Botão Filtros */}
            <Button id="App-button-cor-principal-escura" onClick={toggleFiltros} active={filtros}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
              Filtros
            </Button>

            {/* Botão Importar */}
            <ProtectedActionInterno>
              <Button variant="outline-primary" onClick={toggleImportacao} active={importacaoOpen}>
                <FontAwesomeIcon icon={faFileImport} style={{ marginRight: '10px' }} />
                Importar
              </Button>
            </ProtectedActionInterno>
          </div>

          <div>

            <ProtectedActionOriginador>
              <Button
                onClick={() => navigate('/sistema-usuario/inclusao', { state: { id: 0 } })}
                id="App-button-cor-principal-escura"
              >
                + Novo Usuário
              </Button>
            </ProtectedActionOriginador>

            <Button id="App-button-cor-principal-escura"
              onClick={gerarRelatorio}
              style={{ marginLeft: '10px' }}
            >
              <FontAwesomeIcon icon={faFileExcel} style={{ marginRight: '10px' }} />
              Exportar Relatório
            </Button>
          </div>
        </div>

        {/* --- ÁREA DE IMPORTAÇÃO --- */}
        {importacaoOpen && (
          <div className="card card-body mb-4" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
            <h6 className="card-title mb-3">
              <FontAwesomeIcon icon={faFileImport} className="me-2" />
              Importação em Lote
            </h6>
            <Row className="align-items-end g-3">
              <Col md={3}>
                <Form.Label>Passo 1: Modelo</Form.Label>
                <Button variant="outline-secondary" className="w-100" onClick={handleDownloadModelo}>
                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                  Baixar Modelo
                </Button>
              </Col>

              <Col md={5}>
                <Form.Group controlId="formFile">
                  <Form.Label>Passo 2: Selecione o Arquivo (.xlsx)</Form.Label>
                  <Form.Control
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept=".xlsx, .csv"
                  />
                </Form.Group>
              </Col>

              <Col md={4} className="d-flex gap-2">
                <Button
                  id="App-button-cor-principal-escura"
                  className="flex-grow-1"
                  onClick={handleImportar}
                  disabled={!fileToUpload || importLoading}
                >
                  {importLoading ? <Spinner loading={true} /> : 'Confirmar Importação'}
                </Button>
                <Button variant="secondary" onClick={() => {
                  setImportacaoOpen(false);
                  setImportMessage(null);
                  setFileToUpload(null);
                }}>
                  <FontAwesomeIcon icon={faTimes} />
                </Button>
              </Col>
            </Row>

            {importMessage && (
              <Alert variant={importMessage.type} className="mt-3 mb-0">
                {importMessage.text}
              </Alert>
            )}
          </div>
        )}

        {filtros && (
          <>
            <Row className="mb-4" style={{ marginTop: '15px' }}>
              <Form.Group as={Col} md='2' controlId="formBasicSelect">
                <Form.Label>Código Usuário </Form.Label>
                <input type="text" className="form-control" value={codigoFiltro} onChange={(e) => setCodigoFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>Login</Form.Label>
                <input type="text" className="form-control" value={loginFiltro} onChange={(e) => setLoginFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>Nome </Form.Label>
                <input type="text" className="form-control" value={nomeFiltro} onChange={(e) => setNomeFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='2' controlId="formBasicSelect">
                <Form.Label>CPF</Form.Label>
                <InputMask required mask="999.999.999-99" type="text" className="form-control" value={cpfFiltro} onChange={(e) => setCpfFiltro(e.target.value)} />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md='3' controlId="formBasicSelect">
                <Form.Label>Status</Form.Label>
                <select className="form-select" defaultValue={statusFiltro} value={statusFiltro} onChange={(e) => setStatusFiltro(e.target.value)}>
                  {statusFl.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </Form.Group>

              <Form.Group as={Col} md='3' controlId="formBasicSelect">
                <Form.Label>Tipo Usuário</Form.Label>
                <select required className="form-select" value={roleFiltro?.id || ""} onChange={(e) => {
                  const selectedRole = roles.find((item) => item.id === e.target.value as UUID);
                  setRoleFiltro(selectedRole);
                }}>
                  <option value="">Todos</option>
                  {roles.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.descricao}
                    </option>
                  ))}
                </select>
              </Form.Group>

              <Form.Group as={Col} md='2'>
                <Form.Label>Data Criação Início</Form.Label>
                <Form.Control
                  type="date"
                  value={dataInicioFiltro ? dataInicioFiltro.toISOString().split('T')[0] : ''}
                  onChange={(e) => {
                    if (e.target.value) {
                      const newDate = new Date(e.target.value);
                      newDate.setHours(newDate.getHours() + newDate.getTimezoneOffset() / 60);
                      setDataInicioFiltro(newDate);
                    } else {
                      setDataInicioFiltro(undefined);
                    }
                  }}
                />
              </Form.Group>

              <Form.Group as={Col} md='1' style={{ display: 'flex', marginTop: '30px', width: '1%' }}>
                <strong style={{ marginTop: '8px' }}>a</strong>
              </Form.Group>

              <Form.Group as={Col} md='2'>
                <Form.Label>Data Criação Fim</Form.Label>
                <Form.Control
                  type="date"
                  value={dataFimFiltro ? dataFimFiltro.toISOString().split('T')[0] : ''}
                  onChange={(e) => {
                    if (e.target.value) {
                      const newDate = new Date(e.target.value);
                      newDate.setHours(newDate.getHours() + newDate.getTimezoneOffset() / 60);
                      setDataFimFiltro(newDate);
                    } else {
                      setDataFimFiltro(undefined);
                    }
                  }}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="4">
                <Form.Label>Matriz</Form.Label>
                <Form.Select value={matrizFiltro} onChange={(e) => setMatrizFiltro(e.target.value)}>
                  <option value="">Todos</option>
                  {matrizes.map((item) => (
                    <option key={item.id} value={item.id}>{item.nome}</option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="4">
                <Form.Label>Promotora</Form.Label>
                <Form.Select value={promotoraFiltro} onChange={(e) => setPromotoraFiltro(e.target.value)}>
                  <option value="">Todos</option>
                  {promotoras.map((item) => (
                    <option key={item.id} value={item.id}>{item.nome}</option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="4">
                <Form.Label>Supervisor</Form.Label>
                <Form.Select value={supervisorFiltro} onChange={(e) => setSupervisorFiltro(e.target.value)}>
                  <option value="">Todos</option>
                  {supervisores.map((item) => (
                    <option key={item.id} value={item.id}>{item.nome}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Operador</Form.Label>
                <Form.Select value={operadorFiltro} onChange={(e) => setOperadorFiltro(e.target.value)}>
                  <option value="">Todos</option>
                  {operadores.map((item) => (
                    <option key={item.id} value={item.id}>{item.nome}</option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="6">
                <Form.Label>Ponto de Venda</Form.Label>
                <Form.Select value={pontoVendaFiltro} onChange={(e) => setPontoVendaFiltro(e.target.value)}>
                  <option value="">Todos</option>
                  {pontosVenda.map((item) => (
                    <option key={item.id} value={item.id}>{item.nome}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>

            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
              <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1px' }} />
              </Button>

              <div style={{ display: 'flex', gap: '10px' }}>
                <Button variant="secondary" onClick={() => {
                  setCodigoFiltro(''); setLoginFiltro(''); setNomeFiltro(''); setCpfFiltro('');
                  setStatusFiltro('Todos'); setRoleFiltro(undefined); setDataInicioFiltro(undefined); setDataFimFiltro(undefined);
                  setMatrizFiltro(''); setPromotoraFiltro(''); setSupervisorFiltro(''); setOperadorFiltro(''); setPontoVendaFiltro('');
                  setCurrentPage(0);
                  listarTodosUsuarios(pageSize);
                }}>
                  <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
                </Button>

                <Button id="App-button-cor-principal-escura" onClick={() => {
                  setCurrentPage(0);
                  listarTodosUsuarios(pageSize);
                }}>
                  Pesquisar
                </Button>
              </div>
            </div>
          </>
        )}

        <Row style={{ justifyContent: 'center' }} className="mb-3">
          <Form.Group style={{ marginTop: '10px' }} as={Col} md='2' controlId="formBasicSelect">Registros Por Página</Form.Group>
          <Form.Group as={Col} md='1' controlId="formBasicSelect">
            <select className="form-select"
              defaultValue={pageSize} value={pageSize} onChange={(e) => {
                setPageSize(parseInt(e.target.value));
                // listarTodosUsuarios é chamado pelo useEffect
              }}
            >
              {qtdRegistros.map((qtd, index) => (
                <option key={index} value={qtd}>{qtd}</option>
              ))}
            </select>
          </Form.Group>
        </Row>

        {loading ? <Spinner loading={loading} /> : (
          <div className="table-responsive">
            <div>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col" id="App-header-table" style={{ width: '4%' }}>Código</th>
                    <th scope="col" id="App-header-table" style={{ width: '8%' }}>Login</th>
                    <th scope="col" id="App-header-table" style={{ width: '12%' }}>Nome</th>
                    <th scope="col" id="App-header-table" style={{ width: '9%' }}>CPF</th>
                    <th scope="col" id="App-header-table" style={{ width: '9%' }}>Tipo de Usuário</th>
                    <th scope="col" id="App-header-table" style={{ width: '12%' }}>Vinculo Origem</th>
                    {/* <th scope="col" id="App-header-table" style={{ width: '12%'}}>Promotora</th> */}
                    <th scope="col" id="App-header-table" style={{ width: '12%' }}>E-mail</th>
                    <th scope="col" id="App-header-table" style={{ width: '10%' }}>Data Criação</th>
                    <ProtectedAction>
                      <th scope="col" id="App-header-table" style={{ width: '4%' }}>Alteração</th>
                      <th scope="col" id="App-header-table" style={{ width: '4%' }}>Inativação</th>
                    </ProtectedAction>
                  </tr>
                </thead>
                <tbody>
                  {usuarios.map((item: any) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.login}</td>
                      <td>{item.nome}</td>
                      <td>{item.cpf}</td>
                      <td>{item.nomeRole}</td>
                      <td>{item.nomeOrigem}</td>
                      {/* <td>{item.nomesPromotoras || '-'}</td> */}
                      <td>{item.email}</td>
                      <td>{item.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy') : ''}</td>
                      <ProtectedAction>
                        <td style={{ textAlign: 'center' }}>
                          {/* 4. Link com Slug */}
                          <Link to={`/${slug}/sistema-usuario/alteracao`} state={{ id: item.id }}>
                            <ButtonAlterar />
                          </Link>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {item.ativo ?
                            <ButtonInativar onClick={() => ativarInativarUsuario(item.id, item.ativo)} />
                            :
                            <ButtonAtivar onClick={() => ativarInativarUsuario(item.id, item.ativo)} />
                          }
                        </td>
                      </ProtectedAction>
                    </tr>
                  ))}
                </tbody>
              </table>
              {confirmOpen && (<ConfirmModal message={currentAction?.ativo ? 'Tem certeza que deseja inativar este item?' : 'Tem certeza que deseja ativar este item?'} onConfirm={handleConfirm} onCancel={() => { setConfirmOpen(false); setCurrentAction(null) }} />)}
              <ResponsivePagination
                current={currentPage}
                total={totalPages}
                onPageChange={setCurrentPage} />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default UsuarioComponent;